module.exports = __webpack_public_path__ + "static/media/Barn.96e427d2.png";